export function formatAsSwissDate(dateAsNumber: number): string {
  const date = new Date(dateAsNumber);

  return date.toLocaleDateString('de-CH', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
}